
export function PageVisibility(docIn = document) {
  const doc = docIn;
  let visibilityChange;
  let hidden;
  const handlers = [];

  // https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API
  if (typeof doc.hidden !== 'undefined') { // Opera 12.10 and Firefox 18 and later support
    hidden = 'hidden';
    visibilityChange = 'visibilitychange';
  } else if (typeof doc.msHidden !== 'undefined') {
    hidden = 'msHidden';
    visibilityChange = 'msvisibilitychange';
  } else if (typeof doc.webkitHidden !== 'undefined') {
    hidden = 'webkitHidden';
    visibilityChange = 'webkitvisibilitychange';
  }

  this.isVisible = () => !doc[hidden];

  this.handleVisibilityChange = () => {
    const isVisible = this.isVisible();
    for (const handler of handlers) {
      handler(isVisible);
    }
  };

  this.startTracking = (handler) => {
    handlers.push(handler);
    if (handlers.length === 1) {
      doc.addEventListener(visibilityChange, this.handleVisibilityChange, false);
    }
    handler(this.isVisible()); // current state
  };

  this.stopTracking = (handler) => {
    const index = handlers.indexOf(handler);
    if (index === -1) {
      throw new Error('PageVisibility.stopTracking() invalid handler');
    }
    handlers.splice(index, 1);
    if (handlers.length === 0) {
      doc.removeEventListener(visibilityChange, this.handleVisibilityChange);
    }
  };
}

const pageVisibility = new PageVisibility();

export default pageVisibility;
